import { UnitSevenStatusEnum } from "@project-management-system/shared-models";
import { BeforeInsert, Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('buyer_master')
export class BuyerEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "id",
    })
    id: number;

    @Column("varchar", {
        nullable: true,
        length: 255,
        name: "buyer",
    })
    buyer: string

    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'file_path'
    })
    filePath: string;

    @Column('varchar', {
        nullable: true,
        length: 250,
        name: 'file_name'
    })
    fileName: string;

    @Column('varchar', {
        nullable: true,
        length: 250,
        name: 'original_name'
    })
    originalname: string;

    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user",
    })
    updatedUser: string | null;

    @CreateDateColumn({
        nullable: true,
        name: "updated_at",
    })
    updatedAt: string;

    @VersionColumn({
        nullable: true,
        default: 1,
        name: "version_flag",
    })
    versionFlag: number;

    @Column("boolean", {
        name: "is_active",
        default: true,
        nullable: true,
    })
    isActive: boolean;

    @Column('enum', {
        nullable: true,
        name: 'status',
        enum: UnitSevenStatusEnum
    })
    status: UnitSevenStatusEnum;

    @BeforeInsert()
    transformContentToUpper() {
        this.buyer = this.buyer.toUpperCase();
    }
}